import { all, fork } from 'redux-saga/effects';
import signInSaga from '../../components/SignInForm/sagas';
import signUpSaga from '../../components/FullRegistration/sagas';
import passwordResetSaga from '../../components/PasswordResetForm/sagas';

export default function* () {
  yield all([fork(signInSaga), fork(signUpSaga), fork(passwordResetSaga)]);
}
